module.exports = __webpack_public_path__ + "ba302e2ae395d721cde80a9c3173ca2f.png";